export enum EIdCardVerification {
  Success = 1,
  Failed = 2,
  Pending = 3,
  Expired = 4,
}

export const EIdCardVerificationLabel = {
  [EIdCardVerification.Success]: 'Berhasil',
  [EIdCardVerification.Failed]: 'Gagal',
  [EIdCardVerification.Pending]: 'Menunggu Verifikasi',
  [EIdCardVerification.Expired]: 'Telah Kedaluwarsa',
};

export const EIdCardVerificationColor = {
  [EIdCardVerification.Success]: 'green',
  [EIdCardVerification.Failed]: 'red',
  [EIdCardVerification.Pending]: 'yellow',
  [EIdCardVerification.Expired]: 'gray',
};
